import styled, { css, keyframes } from 'styled-components';
import { generateScales } from '@helpers/generate-media-queries';
import Wrapper from '@components/wrapper.styled';
import Section from '@components/section';

export const PostFeedWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: 2rem;
    width: 100%;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      row-gap: 1.25rem;
    }
  `}
`;

interface StyledSectionProps {
  hasFeatured: boolean;
}

export const StyledSection = styled(Section)<StyledSectionProps>`
  ${({ theme, hasFeatured }) => css`
    background-color: ${theme.colors.white};
    padding-top: ${hasFeatured ? '0rem' : '5.5rem'};
    z-index: 9;
  `}
`;

export const DummySection = styled.div`
  pointer-events: none;
  transition: all 0.5s ease;

  ${({ theme }) => css`
    ${generateScales('padding-top', '3.5rem', '5.5rem', theme)}
    ${generateScales('padding-bottom', '3.5rem', '5.5rem', theme)}
    &.animate {
      display: none;
    }
  `}
`;

export const DummyWrapper = styled(Wrapper)`
  pointer-events: none;
  transition: all 0.5s ease;

  &.animate {
    display: none;
  }
`;

const fadeInKeyframes = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

const fadeInAnimation = () => css`
  animation: ${fadeInKeyframes} 0.5s ease-in;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  margin: 0 auto;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const Divider = styled.div`
  ${({ theme }) => css`
    border-top: 0.1625rem solid ${theme.colors.primary};
    border-bottom: 0.1625rem solid ${theme.colors.primary};
    border-radius: 0.1625rem;
    background-color: ${theme.colors.primary};
    height: 0.325rem;
    width: 4rem;
    transform-origin: left;
    align-self: center;
    margin-bottom: 0.5rem;
    transform-origin: 50% 0;

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      border-top: 0.125rem solid ${theme.colors.primary};
      border-bottom: 0.125rem solid ${theme.colors.primary};
      height: 0.25rem;
      align-self: flex-start;
      width: 3.5rem;
      margin-bottom: 0.75rem;
    }
  `}
`;

export const FadeIn = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: 6rem;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      row-gap: 3rem;
    }

    &.animate {
      ${fadeInAnimation}
    }
  `}
`;

export const StyledWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: column;
  row-gap: 3rem;
  justify-content: center;
  align-items: center;
`;
